import React from 'react'
import './style/index.css'
import icon from '../../assets/qing.png'

export default function Top() {
  return (
    <>
      <div className="top">
        <div className="left">
          <div className="l-one">
            <i className="iconfont icon-diandiandian denglu"></i>
          </div>
          <div className="l-two">上海市</div>

          <div className="r-three">
            <img src={icon} alt="" /> 35°c
          </div>
        </div>
        <div className="right">
          <div className="r-left">
            登录
            <i className="iconfont icon-denglu-copy denglu"></i>
          </div>
          <div className="r-center">
            <i className="iconfont icon-shouji "></i>
          </div>
          <div className="r-right">
            <i className="iconfont icon-shezhi"></i>
          </div>
        </div>
      </div>
      <div className="seach">
        <div className="s-center">
          <div className="s-left">
            <i className="iconfont icon-sousuo"></i>
          </div>
          <input type="text" placeholder="搜索网页" />
          <div className="s-right">
            <i className="iconfont icon-yuyin"></i>
          </div>
        </div>
      </div>
    </>
  )
}
